import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link, Redirect, useHistory } from 'react-router-dom'
import InternetIssue from '../../components/InternetIssue/InternetIssue'
import { handleFullscreen } from '../../views/InstructionsPage/helper'
import {
    HIDE_TIMER,
    SUBMIT_TEST,
    UPDATE_ANTHE_DATA,
    UPDATE_HEADER_VISIBLE,
    UPDATE_TIME,
} from '../../constants/actionTypes'
import Api from '../../data'
import { persistor } from '../../redux/store'
import Button from '../Button/Button'
import PreLoadingScreen from '../PreLoadingScreen/PreLoadingScreen'
import QuestionHeader from '../QuestionHeader/QuestionHeader'
import QuestionSummary from '../QuestionSummary/QuestionSummary'
import './SubmitPage.css'
import { isInPhoneOrTablet } from '../../utils/common/isInPhoneOrTablet'
import { webengageTrackEvent } from 'utils/webengageService'
import { WEBENGAGE_EVENTS } from 'constants/webengageEvents'
import { GOOGLE_TAG_CONSTANTS } from 'constants/googleTagConstants'
import { ANTHE_EXAM_TYPES, ANTHE_TEST_TYPES } from 'constants/examTypeConstants'

const mapStateToProps = (state) => ({
    ...state,
    ...state.testpanel,
    time: state.timer,
    usertestid: state.testStatus,
    testData: state.testpanel,
})

const mapDispatchToProps = (dispatch) => {
    return {
        onSubmitTest: (payload) => dispatch({ type: SUBMIT_TEST, payload }),
        resetTimer: (payload) => dispatch({ type: UPDATE_TIME, payload }),
        hideTimer: (payload) => dispatch({ type: HIDE_TIMER, payload }),
        setAntheData: (payload) => dispatch({ type: UPDATE_ANTHE_DATA, payload }),
        setHeaderVisibility: (payload) =>
            dispatch({ type: UPDATE_HEADER_VISIBLE, payload }),
    }
}

const SubmitPage = (props) => {
    const { t } = useTranslation()
    const [active, setActive] = useState(0)
    const [showError, setshowError] = useState(false)
    const [isRedirect, setisRedirect] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const [showLoading, setShowLoading] = useState(false)
    const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false)
    const [redirectThankYouPage, setRedirectThankYouPage] = useState(false)
    const history = useHistory()
    const handleClick = (index, data) => {
        const _index = parseInt(index, 0)
        if (_index !== active) {
            setActive(_index)
        }
    }

    const isMock = JSON.parse(sessionStorage.getItem('is_mock'))
    const isPreview =
        sessionStorage.getItem('tp_preview_token') &&
        sessionStorage.getItem('test_id')
            ? true
            : false

    function logEvents(eventName, description, extraData) {
        props.handleGTagLogs(eventName, description, {
            user_test_id: props.testStatus?.testStatus?.data?.userTestId,
            ...extraData,
        })
    }
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') {
            const userTestId = props.testStatus?.testStatus?.data?.userTestId
            const testId = props.instructions?.testData?.id
            const testAttemptNo = props.queryparam?.test_attempt
            const rollNo = props.testStatus?.testStatus?.data?.testRollNo
            const deviceId = props.deviceId

            if (userTestId && rollNo && !isPreview) {
                Api.postTabSwitchFullScreenExitLogs({
                    userTestId,
                    testId,
                    testAttemptNo,
                    rollNo,
                    questionId: null,
                    deviceId,
                    activityType: 'tab-change',
                })
                    .then((res) => res.data)
                    .catch((err) => console.error(err))
            }
        }
    }

    useEffect(() => {
        props.hideTimer(true)
        let currentPathname = null
        let currentSearch = null
        history.listen((newLocation, action) => {
            if (action === 'PUSH') {
                if (
                    newLocation.pathname !== currentPathname ||
                    newLocation.search !== currentSearch
                ) {
                    currentPathname = newLocation.pathname
                    currentSearch = newLocation.search

                    history.push({
                        pathname: newLocation.pathname,
                        search: newLocation.search,
                    })
                }
            } else {
                history.go(1)
            }
        })
        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => {
            history.onpopstate = null
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    }, [])

    const handleAntheSubmit = () => {
        logEvents(
            GOOGLE_TAG_CONSTANTS.TAP_SUBMIT_SUMMARY_SCREEN_WEB,
            'User taps on the submit button on the test summary screen',
            {
                success: true,
            },
        )
        setisRedirect(false)
        localStorage.setItem(
            'examName',
            JSON.stringify(props.instructions.testData.title),
        )
        Api.submitTest(props, true)
            .then((res) => res.data)
            .then((res) => {
                if (res.finalSubmit) {
                    logEvents(
                        GOOGLE_TAG_CONSTANTS.POST_LOAD_SCREEN_WEB,
                        'When post load screens comes up before loading of the result',
                        {
                            success: true,
                        },
                    )
                    props.setAntheData(res)
                    history.push({ pathname: '/success' })
                } else {
                    setshowError(true)
                }
            })
            .catch((error) => {
                logEvents(
                    GOOGLE_TAG_CONSTANTS.POST_LOAD_SCREEN_WEB,
                    'When post load screens comes up before loading of the result',
                    {
                        failure: true,
                        reason_for_failure: error,
                    },
                )

                if (error.response !== undefined && error.response.status >= 400) {
                    if (
                        error.response.data.message ===
                        'Test has been already submitted'
                    ) {
                        setisRedirect(true)
                    }
                    setErrorMsg(error.response.data.message)
                    setshowError(true)
                    setisRedirect(false)
                } else {
                    setshowError(true)
                    setisRedirect(false)
                }
            })
            .finally(() => {
                setSubmitBtnDisabled(false)
            })
    }

    const handleSubmit = () => {
        logEvents(
            GOOGLE_TAG_CONSTANTS.TAP_SUBMIT_SUMMARY_SCREEN_WEB,
            'User taps on the submit button on the test summary screen',
            {
                success: true,
            },
        )
        Api.submitTest(props, true)
            .then((res) => {
                if (res.response?.status === 412) {
                    handleLogout(res.response.data?.detailMessage)
                    return
                }
                return res.data
            })
            .then((res) => {
                if (res.finalSubmit) {
                    logEvents(
                        GOOGLE_TAG_CONSTANTS.POST_LOAD_SCREEN_WEB,
                        'When post load screens comes up before loading of the result',
                        {
                            success: true,
                        },
                    )
                    setisRedirect(true)
                    setShowLoading(false)
                } else {
                    setisRedirect(true)
                    setShowLoading(false)
                    setshowError(true)
                }
            })
            .catch((error) => {
                logEvents(
                    GOOGLE_TAG_CONSTANTS.POST_LOAD_SCREEN_WEB,
                    'When post load screens comes up before loading of the result',
                    {
                        failure: true,
                        reason_for_failure: error,
                    },
                )

                setShowLoading(false)
                if (error.response !== undefined && error.response.status >= 400) {
                    if (
                        error.response.data.message ===
                        'Test has been already submitted'
                    ) {
                        if (
                            isMock ||
                            ANTHE_EXAM_TYPES.includes(
                                props.queryparam.exam_type.toLowerCase(),
                            ) ||
                            ANTHE_TEST_TYPES.includes(
                                props?.queryparam?.exam_type?.toLowerCase(),
                            )
                        ) {
                            setRedirectThankYouPage(true)
                        } else {
                            setisRedirect(true)
                        }
                    }
                    setErrorMsg(error.response.data.message)
                    setshowError(true)
                    setisRedirect(false)
                } else {
                    setshowError(true)
                    setisRedirect(false)
                }
            })
    }

    function handleLogout(message) {
        setshowError(true)
        setErrorMsg(message)
        setTimeout(() => {
            window.location.href = props.base_url
        }, 6000)
        persistor.pause()
        persistor.flush().then(() => {
            return persistor.purge()
        })
    }

    let tData = Array.isArray(props.testData.questionset)
        ? [...props.testData.questionset]
        : null
    if (Array.isArray(tData)) {
        let answered = 0,
            notAnswered = 0,
            visited = 0,
            markedForReview = 0,
            ansRev = 0,
            notVisited = 0,
            total = 0
        for (let i = 0; i < tData.length; i++) {
            for (let j = 0; j < tData[i].questionList.length; j++) {
                if (tData[i].questionList[j].question.isAnswered === true) {
                    answered++
                }
                if (tData[i].questionList[j].question.isVisited === true) {
                    visited++
                }
                if (
                    tData[i].questionList[j].question.isMarkedForReview &&
                    !tData[i].questionList[j].question.isAnswered
                ) {
                    markedForReview++
                }
                if (
                    tData[i].questionList[j].question.isMarkedForReview &&
                    tData[i].questionList[j].question.isAnswered
                ) {
                    ansRev++
                }
                if (
                    !tData[i].questionList[j].question.isAnswered &&
                    tData[i].questionList[j].question.isVisited &&
                    !tData[i].questionList[j].question.isMarkedForReview
                ) {
                    notAnswered++
                }
                total++
            }
        }
        notVisited = total - visited
        tData.unshift({
            subject: 'All',
            summary: [],
        })
        tData[0].summary.push({
            total: total,
            answered: answered,
            notanswered: notAnswered,
            markedForReview: markedForReview,
            notvisited: notVisited,
            answeredAndMarkedForReview: ansRev,
        })
    } else {
        setshowError(true)
    }
    // anthe exam types
    if (redirectThankYouPage) {
        return <Redirect to="/success" />
    }
    // other exam types
    if (isRedirect) {
        return <Redirect to="/results" />
    }

    if (Array.isArray(tData) && !showLoading && !showError) {
        return (
            <div className="submit-wrapper">
                <div className="submit-section">
                    <QuestionHeader
                        header={tData}
                        icon={true}
                        handleClick={handleClick}
                        active={active}
                        sectionType="submit"
                    />
                    <main
                        className="submit-question-statistics-wrapper"
                        style={{ margin: '0 15px' }}
                    >
                        <div className="tab-container-wrapper-submit">
                            <QuestionSummary summary={tData} active={active} />
                        </div>
                    </main>
                    {props.time.t !== 0 ? (
                        <footer className="submit-wrapper-sticky">
                            <h4 className="submit-confirm-text">
                                {t('Are you sure you want to submit?')}
                            </h4>
                            <div className="submit-buttons">
                                <Link
                                    to={{
                                        pathname: '/testpanel',
                                        state: { property_id: 'DontShowPopUp' },
                                    }}
                                    className="submit-btn"
                                >
                                    <Button
                                        onClick={async () => {
                                            sessionStorage.setItem(
                                                'isRedirected',
                                                true,
                                            )
                                            if (!isPreview) {
                                                logEvents(
                                                    GOOGLE_TAG_CONSTANTS.TAP_RESUME_SUMMAY_SCREEN_WEB,
                                                    'User taps on the resume button on the test summary screen',
                                                    {
                                                        success: true,
                                                    },
                                                )

                                                handleFullscreen()
                                            }
                                        }}
                                        classes="btn_resume"
                                        name={'Resume'}
                                    />
                                </Link>
                                <div className="submit-btn">
                                    <Button
                                        name={'Submit'}
                                        classes={`btn_submit ${
                                            submitBtnDisabled
                                                ? 'btn_disabled_submitted'
                                                : ''
                                        }`}
                                        disabled={submitBtnDisabled}
                                        style={{
                                            width:
                                                isInPhoneOrTablet === true
                                                    ? '100%'
                                                    : '100%',
                                        }}
                                        onClick={() => {
                                            if (isPreview) {
                                                setRedirectThankYouPage(true)
                                            } else if (
                                                !isMock &&
                                                ANTHE_EXAM_TYPES.includes(
                                                    props.queryparam.exam_type.toLowerCase(),
                                                )
                                            ) {
                                                setSubmitBtnDisabled(true)
                                                handleAntheSubmit()
                                                webengageTrackEvent(
                                                    WEBENGAGE_EVENTS.TP_SUBMIT_TEST,
                                                )
                                            } else {
                                                setSubmitBtnDisabled(true)
                                                handleSubmit()
                                                webengageTrackEvent(
                                                    WEBENGAGE_EVENTS.TP_SUBMIT_TEST,
                                                )
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </footer>
                    ) : (
                        <Link to="/success">
                            <Button
                                name={'OK'}
                                background={'#01b0f5'}
                                color={'#fff'}
                                fontSize={'12px'}
                                height={'40px'}
                                width={'300px'}
                                margin={'auto'}
                            />
                        </Link>
                    )}
                </div>
            </div>
        )
    }
    if (showLoading && !showError) {
        return (
            <PreLoadingScreen
                isLoaderVisible={false}
                hideProgressBar={true}
                text={t('we are fetching your analytical report')}
                done={100}
            />
        )
    }
    return (
        <InternetIssue
            message={errorMsg !== '' ? t(errorMsg) : t('Something Went Wrong')}
        />
    )
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubmitPage))
